import { Promotion } from "../../Model";
import { AdminBarberRepository } from "../../Repository";

export async function addPromotion(
  promotion: Promotion,
  repository: AdminBarberRepository
): Promise<string | null> {
  return repository.setPromotion(promotion);
}
